import { useEffect, useState } from "react";
import { Download, X, Share } from "lucide-react";

const DISMISS_KEY = "matcom_pwa_dismissed";

export const InstallPrompt = () => {
  const [deferred, setDeferred] = useState(null);
  const [showIos, setShowIos] = useState(false);
  const [hidden, setHidden] = useState(() => localStorage.getItem(DISMISS_KEY) === "1");

  useEffect(() => {
    const standalone =
      window.matchMedia("(display-mode: standalone)").matches ||
      window.navigator.standalone === true;
    if (standalone) return;

    const onPrompt = (e) => {
      e.preventDefault();
      setDeferred(e);
    };
    window.addEventListener("beforeinstallprompt", onPrompt);

    // iOS Safari has no beforeinstallprompt — show manual hint
    const isIos = /iphone|ipad|ipod/i.test(navigator.userAgent);
    if (isIos) setShowIos(true);

    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, []);

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, "1");
    setHidden(true);
  };

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    await deferred.userChoice;
    setDeferred(null);
  };

  if (hidden || (!deferred && !showIos)) return null;

  return (
    <div
      data-testid="pwa-install-banner"
      className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[1200] w-[calc(100%-2rem)] max-w-md rounded-xl border border-cyan-500/30 bg-slate-900/95 backdrop-blur-md shadow-2xl px-4 py-3 flex items-center gap-3"
    >
      <img src="/icon-192.png" alt="" className="h-10 w-10 rounded-lg shrink-0" />
      <div className="min-w-0 flex-1">
        <p className="text-sm font-semibold text-slate-100">Install Matcom CAD</p>
        {deferred ? (
          <p className="text-xs text-slate-400">Add to your home screen for fullscreen MDT access</p>
        ) : (
          <p className="text-xs text-slate-400 flex items-center gap-1 flex-wrap">
            Tap <Share className="h-3.5 w-3.5 inline text-cyan-400" /> then &quot;Add to Home Screen&quot;
          </p>
        )}
      </div>
      {deferred && (
        <button
          data-testid="pwa-install-btn"
          onClick={install}
          className="shrink-0 inline-flex items-center gap-1.5 rounded-lg bg-cyan-600 hover:bg-cyan-500 text-white text-xs font-semibold px-3 py-2 transition-colors"
        >
          <Download className="h-3.5 w-3.5" /> Install
        </button>
      )}
      <button
        data-testid="pwa-dismiss-btn"
        onClick={dismiss}
        aria-label="Dismiss"
        className="shrink-0 text-slate-500 hover:text-slate-300 transition-colors"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
};

export default InstallPrompt;
